<div
  class="synced-data-filter"
  [ngClass]="{ checked: onlyLocalData }"
  matTooltip="Hides data that is synchronized with Inventa Web"
>
  <div class="synced-data-filter__title">
    <h3>{{ title() }}</h3>
  </div>
  <div class="synced-data-filter__toggle">
    <mat-slide-toggle [checked]="onlyLocalData" (change)="toggle()"></mat-slide-toggle>
  </div>
</div>
